import { render, staticRenderFns } from "./Sorteo2.vue?vue&type=template&id=8520aac0&"
import script from "./Sorteo2.vue?vue&type=script&lang=js&"
export * from "./Sorteo2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports